import Event from '@alife/operate-keyevent';
const event = new Event();
export default event;
